export default __webpack_public_path__ + "loading.9d9d8d45736791162b2cb636bf8f140c.gif";